import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconRecKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRecKeyframe"><Path d="M12 2L2 12L12 22L22 12L12 2Z" stroke="currentColor"/><Circle cx="12" cy="12" r="3" stroke="currentColor"/></CentralIconBase>;
});

export default IconRecKeyframe;
